module.exports = __webpack_public_path__ + "img/loginQuoteImage01.ad251e4e.webp";